module.exports = "## Date Picker\n[Date Pickers](https://www.google.com/design/spec/components/pickers.html#pickers-date-pickers) are used to select a single date for an input. \n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/DatePicker/README.md
 ** module id = 962
 ** module chunks = 0
 **/